import { jsToFlutter } from "./js-to-flutter";

const MINI_PROGRAM_SDK_URL = "https://res.wx.qq.com/open/js/jweixin-1.3.2.js";

function isMiniProgramContainer() {
  return window.__wxjs_environment === "miniprogram";
}

function isHXAppContainer() {
  return /mgyk-ios-app|mgyk-android-app/i.test(
    navigator.userAgent.toLocaleLowerCase()
  );
}

function normalizeVideoParams(params = {}) {
  const courseId = params.courseId || params.course_id;
  const unitId = params.unitId || params.unit_id;
  const lessonId = params.lessonId || params.lesson_id || params.id;
  if (!courseId || !unitId || !lessonId) return null;
  return {
    courseId,
    unitId,
    lessonId,
  };
}

function normalizeCourseDetailParams(params = {}) {
  const courseId = params.courseId || params.course_id || params.id;
  if (!courseId) return null;
  return { courseId };
}

function loadMiniProgramSdk(callback) {
  if (window.wx?.miniProgram) {
    callback();
    return;
  }

  const existingScript = document.querySelector(
    `script[src="${MINI_PROGRAM_SDK_URL}"]`
  );
  if (existingScript) {
    existingScript.addEventListener("load", callback, { once: true });
    return;
  }

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = MINI_PROGRAM_SDK_URL;
  script.onload = callback;
  document.head.appendChild(script);
}

function openMiniProgramVideoPlayer(params = {}) {
  const normalized = normalizeVideoParams(params);
  if (!normalized) return false;

  const { courseId, unitId, lessonId } = normalized;
  const url = `/learning/video-play/index?courseId=${courseId}&unitId=${unitId}&lessonId=${lessonId}`;
  loadMiniProgramSdk(() => {
    window.wx?.miniProgram?.navigateTo({ url });
  });
  return true;
}

function openAppVideoPlayer(params = {}) {
  const normalized = normalizeVideoParams(params);
  if (!normalized) return false;

  const { courseId, unitId, lessonId } = normalized;
  jsToFlutter("videoPlayer", {
    course_id: courseId,
    unit_id: unitId,
    lesson_id: lessonId,
  });
  return true;
}

function openMiniProgramCourseDetail(params = {}) {
  const normalized = normalizeCourseDetailParams(params);
  if (!normalized) return false;

  loadMiniProgramSdk(() => {
    window.wx?.miniProgram?.redirectTo({
      url: `/learning/course-detail/index?courseId=${normalized.courseId}`,
    });
  });
  return true;
}

function openAppCourseDetail(params = {}) {
  const normalized = normalizeCourseDetailParams(params);
  if (!normalized) return false;

  jsToFlutter(
    "openPage",
    { courseId: normalized.courseId },
    { name: "myCourseDetail" }
  );
  return true;
}

export const nativeBridge = {
  openVideoPlayer(params = {}) {
    if (isMiniProgramContainer()) {
      return openMiniProgramVideoPlayer(params);
    }
    if (isHXAppContainer()) {
      return openAppVideoPlayer(params);
    }
    return false;
  },

  openCourseDetail(params = {}) {
    if (isMiniProgramContainer()) {
      return openMiniProgramCourseDetail(params);
    }
    if (isHXAppContainer()) {
      return openAppCourseDetail(params);
    }
    return false;
  },
};
